<div class="d-flex align-items-center banner"
    [ngClass]="{'recruitment' : isRecruitment, 'pre-boarding': !isRecruitment}">
    <div class="flex-grow-1">
        <h6 class="m-0"><strong>{{ header }}</strong> {{ candidateInfo }} <span style="float:right;">
                {{employeeStatus}}
            </span></h6>

    </div>
    <div class="" *ngIf="isRecruitment && !isDraftStatus">
        <button (click)="showRecruitementEditHistory()" class="btn btn-secondary btn-sm bg-white"
            title="Profile History">
            <img src="design/images/history.png" />
        </button>
    </div>
    <div class="" *ngIf="!isRecruitment">
        <button (click)="showCandidateEditHistory()" class="btn btn-secondary btn-sm bg-white"
            title="Candidate History">
            <img src="design/images/history.png" />
        </button>
    </div>
</div>

<div class="proces" [ngClass]="{'recruitmentproces' : isInvite}">
    <div class="line"></div>
    <ul class="nav">
        <li *ngFor="let step of steps; let index = index;">
            <a data-toggle="tab" class="cursor-pointer" [class.active]="index==activeTabIdx" (click)="showTab(index)">
                <div class="icon">
                    <img src="design/images/file.png" />
                </div>
            </a>
        </li>

        <li [class.disabled]="!canUploadDocuments"
            ngbTooltip="Document upload is allowed only after saving the profile."
            [disableTooltip]="canUploadDocuments">
            <a data-toggle="tab" class="cursor-pointer" [class.active]="steps.length==activeTabIdx"
                (click)="showTab(steps.length)">
                <div class="icon">
                    <img src="design/images/fileup.png" />
                </div>
            </a>
        </li>
    </ul>

    <div class="tab-content mt-5">
        <div class="tab-pane fade" [ngClass]="{'active show':index==activeTabIdx}" id="tab{{index}}"
            *ngFor="let step of steps; let index = index; let first = first; let last = last;">
            <formly-form [form]="formArray.at(index)" [fields]="step.fields" [model]="model"></formly-form>
            <div [hidden]="!showRpInfo" id="tabx{{index}}"
                *ngFor="let step of rpSteps; let index = index; let last = last;">
                <formly-form [form]="rpForm.at(index)" [fields]="step.fields"
                    [model]="model.candidateProfileAdditionalInfo"></formly-form>
            </div>


            <div class="row mt-4 mb-3">

                <ng-container>
                    <div class="col text-center">
                        <button class="btn btn-outline-primary me-2" *ngIf="!canSave && !first"
                            (click)="next(activeTabIdx - 1)">
                            Back
                        </button>
                        <ng-template *ngTemplateOutlet="intialcontrols"></ng-template>
                    </div>
                </ng-container>

            </div>
        </div>

        <div class="tab-pane fade" [ngClass]="{'active show':steps.length==activeTabIdx}" id="tab4">
            <eos-file-upload [showingFileUpload]="showingFileUpload" (GetDocList)="setDocList($event)"
                [allowDocCall]="allowDocCall" [profileId]="profileId" [cProfile]="model" [toolModule]="'RMT'"
                [pbProfile]="pbProfile" [lookupType]="lookupType" [readonly]="!isEditable" [uploadonly]="ifUploadOnly" [candidateForm]="formArray"
                (GetDocumentEvent)="GetDocuments($event)"></eos-file-upload>
            <div class="mt-3" *ngIf="isPTC && pbProfile.pbStatusID !== 1">
                <formly-form *ngFor="let step of additionalSteps; let index = index" [form]="pbFormArray.at(index)"
                    [fields]="step.fields" [model]="pbProfile"></formly-form>
            </div>

            <div class="row mt-2 mb-3">
                <div class="col-12">
                    <label>Notes</label>
                    <textarea [disabled]="!isEditable || !canSave" spellcheck="true" class="form-control"
                        [(ngModel)]="model.notes" rows="4"></textarea>
                </div>
                <ng-template *ngTemplateOutlet="finalcontrols"></ng-template>
            </div>
        </div>
    </div>
</div>

<ng-template #intialcontrols>

    <button class="btn btn-outline-primary me-2" (click)="onCancel()">
        Close
    </button>

    <button class="btn btn-secondary me-2" *ngIf="!canSave" (click)="next(activeTabIdx + 1)">
        Next
    </button>
    <button [disabled]="!enableSave" eosDebounce class="btn btn-outline-primary me-2" *ngIf="canSave"
        (debounceClick)="saveDraft(model)">
        Save
    </button>

    <button [disabled]="!enableSave" eosDebounce class="btn btn-secondary me-2" *ngIf="canSave"
        (debounceClick)="saveAndContinue(model)">
        Save & Continue
    </button>

</ng-template>



<ng-template #finalcontrols>
    <div class="col-12 mt-4 text-center">


        <button class="btn btn-outline-primary me-2" (click)="onCancel()">
            Close
        </button>
        <button class="btn btn-outline-primary me-2" *ngIf="!canSave" (click)="next(activeTabIdx - 1)">
            Back
        </button>
        <button [disabled]="!enableSave" eosDebounce class="btn btn-outline-primary me-2" *ngIf="canSave"
            (debounceClick)="saveDraft(model)">
            Save
        </button>
        <button eosDebounce class="btn btn-outline-primary me-2"
            title="When this button is used, a profile will be created in TMT which triggers the invitation to Timeline and Timeline then triggers the invitation to Gateway"
            [disabled]="model.inviteEnabled" *ngIf="canInvite && !isAutoPopulated" (debounceClick)="sendInvite(model)">
            Invite to timeline
        </button>

        <button eosDebounce class="btn btn-outline-primary me-2"
            title="When this button is used, a profile will be created in TMT which triggers the invitation to Gateway only."
            *ngIf="canInvite && !isAutoPopulated" (debounceClick)="directInvite(model)">
            Invite to gateway
        </button>


        <button eosDebounce class="btn btn-secondary me-2" *ngIf="canInvite && isAutoPopulated"
            (debounceClick)="sendInvite(model)">
            Submit candidate details
        </button>
        <button eosDebounce class="btn btn-outline-primary me-2" *ngIf="canCancelInvite"
            (debounceClick)="cancelInvite()">
            Cancel invite
        </button>

        <button eosDebounce class="btn btn-outline-primary me-2" *ngIf="canResendInvite"
            (debounceClick)="sendInviteMail()">
            Resend invite
        </button>

        <button eosDebounce class="btn btn-secondary me-2" *ngIf="canSubmit && !canInvite"
            (debounceClick)="submit(model)" type="submit">
            Submit
        </button>
        <button eosDebounce class="btn btn-outline-primary me-2" *ngIf="canReject" (debounceClick)="rejectProfile()">
            Reject
        </button>
        <button eosDebounce class="btn btn-secondary me-2" *ngIf="canApprove" (debounceClick)="approveProfile()">
            Approve
        </button>

    </div>
</ng-template>
